import { FIELD_TYPES } from '@witmetrics/utils/constants';
import type { FormFieldTypeId } from '@witmetrics/utils';

export const classes = {
  wrapper:
    'flex justify-start gap-4 mb-4 px-4 py-4 rounded-xl border border-transparent bg-white dark:bg-[#332e43] shadow-card',
  active: 'border-orange-2',
  iconWrapper: 'flex justify-center item-start',
  contentWrapper: 'grow',
  inlineContent: 'grid grid-cols-2 grid-rows-1 items-center',
  wrappedContent: 'flex flex-col gap-2',
  title: 'text-sm font-semibold text-grey-8 dark:text-mauve-1',
  description: 'text-xs text-grey-8 dark:text-mauve-1 tracking-wide',
  inlineInput: 'place-end',
  selectorInput: 'grow',
  wrappedInput: 'w-full',
  input: 'w-full',
  booleanWrapper: 'w-full grow place-end',
};

export function getInputType(fieldTypeId: FormFieldTypeId) {
  const isInline = [
    FIELD_TYPES.SELECT.id,
    FIELD_TYPES.BOOLEAN.id,
    FIELD_TYPES.DATE.id,
    FIELD_TYPES.DATETIME.id,
  ].includes(fieldTypeId);

  return {
    isInline,
    isSelector: isInline && fieldTypeId !== FIELD_TYPES.BOOLEAN.id,
  };
}
